/**
 * The palette's search filter: every word the user typed must be the START of
 * some word in the item's text (its `value` plus its `keywords`),
 * case-insensitive, in any order.
 *
 * Replaces cmdk's default fuzzy scorer, which matches a query's letters in
 * order ANYWHERE in the text. That made "add" hit "Audit Logs" (A-u-d-it …
 * au-d-it-logs) and "Danger zone" (d-A-nger … D-anger … d-anger) — rows with
 * no word "add" at all — because an item's text repeats its title in the
 * breadcrumb and the route.
 *
 * Words are split on anything that isn't a letter or digit, so a route like
 * `/settings?section=danger` contributes "settings", "section", "danger" and
 * `api-keys` contributes "api", "keys". Returns cmdk's score contract: `0`
 * hides the item, anything above keeps it (all matches score the same, so the
 * registry's own order is kept).
 */
export function commandPaletteFilter(value: string, search: string, keywords?: string[]): number {
  const queryWords = toWords(search);
  if (queryWords.length === 0) return 1;
  const itemWords = toWords([value, ...(keywords ?? [])].join(' '));
  return queryWords.every((q) => itemWords.some((w) => w.startsWith(q))) ? 1 : 0;
}

function toWords(text: string): string[] {
  return text.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
}
